<template>
  <div data-cy="myReleaseNoteTable">
    <pack-info :showMenu="true"></pack-info>
    <v-container fluid grid-list-md>
      <v-row class="och-topMargin--packInfoOffset">
        <v-col sm="12">
          <h2 class="title font-weight-thin" data-cy="packLead-pageHeader" v-if="isPackLead">Pack Lead Dashboard</h2>
          <widget-pack-lead v-if="isPackLead" data-cy="qaDashboard__widget--packLead"></widget-pack-lead>
          <h2 class="title font-weight-thin">My Release Notes</h2>
          <widget-active-release-notes></widget-active-release-notes>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PackInfo from "@/components/packInfo";

import WidgetActiveReleaseNotes from "./qa/WidgetActiveReleaseNotes";
import WidgetPackLead from "./qa/widgetPackLead/WidgetPackLead";

export default {
  components: {
    PackInfo,
    WidgetActiveReleaseNotes,
    WidgetPackLead,
  },
  computed: {
    isPackLead() {
      const {
        $store: {
          state: {
            pack: {
              pack: { packLead },
            },
            session: { username },
          },
        },
      } = this;

      return packLead === username;
    },
  },
};
</script>
